import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext.jsx";
import { useAuthContext } from "../context/authContextInstance.jsx";
import {
  FaShoppingCart,
  FaBars,
  FaUser,
  FaSignOutAlt,
  FaSignInAlt,
  FaUserPlus,
  FaSun,
  FaMoon,
} from "react-icons/fa";

function Nav() {
  const { getCartItemsCount } = useCart();
  const { cerrarSesion, isAuthenticated, usuario } = useAuthContext();
  const itemsCount = getCartItemsCount();
  const [menuOpen, setMenuOpen] = useState(false);
  const [theme, setTheme] = useState(() => {
    // Obtener tema guardado o usar oscuro por defecto
    return localStorage.getItem("theme") || "dark";
  });
  const navigate = useNavigate();

  // Aplicar tema al cargar
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "dark" ? "light" : "dark"));
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  const handleLogout = () => {
    cerrarSesion();
    closeMenu();
    navigate("/");
  };

  return (
    <nav>
      <div className="logo">
        <img
          src="/logoclo2.jpg"
          alt="LA CLO BRAND"
          style={{ height: "100%" }}
        />
      </div>

      {/* Botón hamburguesa */}
      <button
        className="hamburger-btn"
        onClick={toggleMenu}
        aria-label="Menú de navegación"
      >
        <FaBars />
      </button>

      {/* Menú de navegación */}
      <ul className={menuOpen ? "nav-menu active" : "nav-menu"}>
        <li>
          <Link to="/" onClick={closeMenu}>
            Inicio
          </Link>
        </li>
        <li>
          <Link to="/Productos" onClick={closeMenu}>
            Productos
          </Link>
        </li>
        <li>
          <Link to="/Contacto" onClick={closeMenu}>
            Contacto
          </Link>
        </li>
        <li>
          <Link to="/Carrito" onClick={closeMenu} className="cart-link">
            <FaShoppingCart style={{ fontSize: "1.2rem" }} /> Carrito
            {itemsCount > 0 && (
              <span className="cart-badge">
                {itemsCount > 99 ? "99+" : itemsCount}
              </span>
            )}
          </Link>
        </li>

        {/* Autenticación */}
        {isAuthenticated ? (
          <>
            {/* Dashboard: solo visible para admin y editor */}
            {usuario &&
              (usuario.rol === "admin" || usuario.rol === "editor") && (
                <li>
                  <Link to="/Dashboard" onClick={closeMenu}>
                    <FaUser
                      style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                    />
                    Dashboard
                  </Link>
                </li>
              )}
            <li>
              <button onClick={handleLogout} className="logout-btn">
                <FaSignOutAlt
                  style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                />
                Cerrar Sesión
              </button>
            </li>
          </>
        ) : (
          <>
            <li>
              <Link to="/Login" onClick={closeMenu}>
                <FaSignInAlt
                  style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                />
                Login
              </Link>
            </li>
            <li>
              <Link to="/Registro" onClick={closeMenu}>
                <FaUserPlus
                  style={{ fontSize: "1rem", marginRight: "0.5rem" }}
                />
                Registrarse
              </Link>
            </li>
          </>
        )}

        {/* Botón de cambio de tema */}
        <li>
          <button
            onClick={toggleTheme}
            className="theme-toggle"
            aria-label="Cambiar tema"
          >
            {theme === "dark" ? (
              <>
                <FaSun /> Claro
              </>
            ) : (
              <>
                <FaMoon /> Oscuro
              </>
            )}
          </button>
        </li>
      </ul>
    </nav>
  );
}

export default Nav;
